import { createAction, props } from '@ngrx/store';
import { ClockInTypeEntity } from '../../entities/clock-in-type.entity';

export const ClockInTypeActionTypes = {
    Load: createAction('data/clock-in-type/get'),
    UpdateAll: createAction('data/clock-in-type/updateAll', props<{ Payload: ClockInTypeEntity[]; updateLatestUpdatedAt?: boolean; }>()),
};
